/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Delete_EventInputs */

const en_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Event`)
};

const fr_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'evenement`)
};

const de_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschereignis`)
};

const it_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina evento`)
};

const ru_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить событие`)
};

const es_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar evento`)
};

const zh_cn2_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除事件`)
};

const ja_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントを削除`)
};

const hi_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट हटाएं`)
};

const pt_pt2_shortcut_keys_name_delete_event = /** @type {(inputs: Shortcut_Keys_Name_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir evento`)
};

/**
* | output |
* | --- |
* | "Delete Event" |
*
* @param {Shortcut_Keys_Name_Delete_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_delete_event = /** @type {((inputs?: Shortcut_Keys_Name_Delete_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Delete_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_delete_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_delete_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_delete_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_delete_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_delete_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_delete_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_delete_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_delete_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_delete_event(inputs)
	return en_shortcut_keys_name_delete_event(inputs)
});